export default __webpack_public_path__ + "static/media/Angerwake Helm.045ce693.jpg";